module.exports = __webpack_public_path__ + "static/media/IMG_4266.b76f0c30.PNG";